import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { API_BASE_URL } from "../../utils/constants";
import ReusableTable from "../../components/ReusableTable";
import ClearForm from "../../components/Clearform";
import CustomStepper from "../../components/CustomStepper";
// import ProgressBar from "../../components/ProgressBar";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
import { Link } from "react-router-dom";
import LotExcelUpload from "./LotExcelUpload";
import LotVerifyUpload from "./LotVerifyUpload";

const UploadLot = () => {
  // Bank & Product state
  const [banks, setBanks] = useState([]);
  const [bankId, setBankId] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProductID, setSelectedProductID] = useState(null);
  const [isDataPresent, setIsDataPresent] = useState(false);
  // Excel column setup of the selected product (Banks & Products)
  const [uploadConfig, setUploadConfig] = useState(null);
  const [uploadConfigError, setUploadConfigError] = useState("");

  // Excel Data
  const [excelData, setExcelData] = useState([]);
  const [errorResponses] = useState([]);
  const [errorExcelBlob, setErrorExcelBlob] = useState(null);
  const [errorCount, setErrorCount] = useState(0);

  // UI State
  const [activeStep, setActiveStep] = useState(0);
  const [progress, setProgress] = useState(0);
  const [prog, setProg] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [clearForm, setClearForm] = useState(false);
  const [verified, setVerified] = useState(false);
  const [showProgress, setShowProgress] = useState(false);

  const [validationErrors, setValidationErrors] = useState([]);
  // Not errors: Excel columns outside the product's setup (ignored) and optional columns the Excel lacks (left empty)
  const [columnNotes, setColumnNotes] = useState({ unused: [], missingOptional: [] });

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // 1️⃣ Fetch Banks
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Client`);
        const result = await response.json();
        const parsed = Array.isArray(result) ? result : JSON.parse(result);
        setBanks(parsed.filter((bank) => bank.Status !== 0));
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };
    fetchBanks();
  }, []);

  // 2️⃣ Fetch Products when bank changes
  useEffect(() => {
    if (!bankId) return;
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products?client_id=${bankId}`
        );
        const result = await response.json();
        const parsed = (Array.isArray(result) ? result : JSON.parse(result)).filter(
          (product) => product.Status !== 0
        );
        setProducts(parsed);
        setSelectedProductID(parsed[0]?.Product_id || null);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, [bankId]);

  const selectedProduct = products.find(
    (item) => String(item.Product_id) === String(selectedProductID)
  );
  const isConfigured = Boolean(selectedProduct?.isConfigured);

  // 2b. Load the selected product's Excel column setup
  useEffect(() => {
    setUploadConfig(null);
    setUploadConfigError("");
    if (!isConfigured) return;
    const fetchUploadConfig = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products/${selectedProductID}/upload-config`
        );
        const result = await response.json();
        if (!response.ok) throw new Error(result?.message || "Could not load product setup");
        setUploadConfig(result);
      } catch (error) {
        setUploadConfigError(error.message);
      }
    };
    fetchUploadConfig();
  }, [selectedProductID, isConfigured]);

  // console.log(selectedProductID);
  // console.log(bankId);
  
  

  // 3️⃣ Handlers
  const handleBankChange = (e) => setBankId(e.target.value);
  const handleProductChange = (e) => setSelectedProductID(e.target.value);

  const handleFileChange = (data) => {
    const updatedData = data.map(({ SR_NO, ...rest }) => rest);
    setExcelData(updatedData);
    setTotalRecords(updatedData.length);
    setActiveStep(1);
  };

  const handleErrorFileGenerated = (errorFile) => setErrorExcelBlob(errorFile);
  const handleErrorCount = (count) => setErrorCount(count);
  const handleStepChange = (step) => setActiveStep(step);
  const handleUploadProgress = (value) => setProgress(value);

  const downloadErrorExcel = (e) => {
    e.preventDefault();
    if (!errorExcelBlob) return;
    const link = document.createElement("a");
    link.href = URL.createObjectURL(errorExcelBlob);
    link.download = "LOT Excel - problems to fix.xlsx";
    link.click();
  };

  const SHOWN_PROBLEMS = 15;

  // 4️⃣ Pagination setup
  const totalPages = Math.ceil(excelData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentRows = excelData.slice(startIndex, startIndex + rowsPerPage);

  return (
    <div className="container">
      {/* Stepper */}
      <div className="row">
        <div className="col-md-12">
          <CustomStepper
            steps={["Select Excel", "Verify Data", "Upload Excel"]}
            activeStep={activeStep}
          />
        </div>
      </div>

      {/* Progress bar */}
      {excelData.length > 0 && showProgress && !clearForm && (
        <div className="row mt-2">
          <div className="col-md-12">
            <div className="progress-container">
              <p className="progress-text">
                {prog}/{totalRecords} records uploaded
              </p>
              <div className="progress-bar-background mt-3">
                <div
                  className="progress-bar"
                  style={{ width: `${(prog / totalRecords) * 100}%` }}
                >
                  {Math.round((prog / totalRecords) * 100)}%
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bank & Product Selection */}
      {excelData.length === 0 && (
        <div className="row justify-content-center align-items-center mt-3">
          <div className="col-md-4">
            <Form.Select
              onChange={handleBankChange}
              className="custom_input"
              style={{ fontSize: "12px" }}
            >
              <option value="" disabled selected>
                Choose a Bank
              </option>
              {banks.map((item) => (
                <option key={item.Client_id} value={item.Client_id}>
                  {item.client_name}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="col-md-4">
            <Form.Select
              onChange={handleProductChange}
              className="custom_input"
              style={{ fontSize: "12px" }}
              value={selectedProductID}
            >
              <option value="" disabled>
                Choose a Product
              </option>
              {products.map((item) => (
                <option key={item.Product_id} value={item.Product_id}>
                  {item.Product_name}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="col-md-4">
            {!selectedProduct ? (
              <p style={{ color: "red", fontSize: "12px" }}>Please select a product</p>
            ) : !isConfigured ? (
              <p style={{ color: "red", fontSize: "12px" }}>
                Excel columns for this product are not set up yet.{" "}
                <Link to="/instdashboard/uploadalot/banks">Set them up in Banks &amp; Products</Link>
              </p>
            ) : uploadConfigError ? (
              <p style={{ color: "red", fontSize: "12px" }}>{uploadConfigError}</p>
            ) : uploadConfig ? (
              <LotExcelUpload
                config={uploadConfig}
                onFileChange={handleFileChange}
                onErrorFileGenerated={handleErrorFileGenerated}
                onErrorCount={handleErrorCount}
                setIsDataPresent={setIsDataPresent}
                setValidationErrors={setValidationErrors}
                onColumnNotes={setColumnNotes}
              />
            ) : (
              <p style={{ fontSize: "12px" }}>Loading product setup...</p>
            )}
          </div>
        </div>
      )}

      {/* Problems found in the Excel, in plain words with how to fix each */}
      {validationErrors.length > 0 && excelData.length === 0 && (
        <div className="mt-3 p-3 rounded" style={{ background: "#fdecea", border: "1px solid #f5c2c7", fontSize: "13px" }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong className="text-danger">
              We found {errorCount} problem{errorCount === 1 ? "" : "s"} in this Excel. Please fix {errorCount === 1 ? "it" : "them"} and choose the file again.
            </strong>
            {errorExcelBlob && (
              <a href="#" onClick={downloadErrorExcel} className="text-danger fw-bold" style={{ whiteSpace: "nowrap" }}>
                ⬇ Download the full list
              </a>
            )}
          </div>
          <table className="table table-sm table-bordered mb-1 bg-white" style={{ fontSize: "12px" }}>
            <thead className="table-light">
              <tr>
                <th style={{ width: "60px" }}>Row</th>
                <th style={{ width: "160px" }}>Column</th>
                <th>Problem</th>
                <th>How to fix</th>
              </tr>
            </thead>
            <tbody>
              {validationErrors.slice(0, SHOWN_PROBLEMS).map((p, i) => (
                <tr key={i}>
                  <td>{p.row}</td>
                  <td style={{ wordBreak: "break-word" }}>{p.column || "—"}</td>
                  <td>{p.problem}</td>
                  <td>{p.fix}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {validationErrors.length > SHOWN_PROBLEMS && (
            <small className="text-muted">
              Showing the first {SHOWN_PROBLEMS}. Download the full list to see all {validationErrors.length}.
            </small>
          )}
          <div className="mt-1">
            <small className="text-muted">Not sure about the format? Use "Download the LOT template" next to the file box.</small>
          </div>
        </div>
      )}

      {/* Notes about columns (not errors) */}
      {validationErrors.length === 0 && excelData.length > 0 && (columnNotes.missingOptional.length > 0 || columnNotes.unused.length > 0) && (
        <div className="mt-2 p-2 rounded" style={{ background: "#fff3cd", color: "#664d03", fontSize: "12px" }}>
          {columnNotes.missingOptional.length > 0 && (
            <div>These optional columns are not in your Excel, so those details will be left empty: {columnNotes.missingOptional.join(", ")}</div>
          )}
          {columnNotes.unused.length > 0 && (
            <div>These columns are not part of this product's setup and will be ignored: {columnNotes.unused.join(", ")}</div>
          )}
        </div>
      )}

      {/* Verify & Upload */}
      {uploadConfig && (
        <LotVerifyUpload
          config={uploadConfig}
          excelData={excelData}
          bankId={bankId}
          selectedProductID={selectedProductID}
          setVerified={setVerified}
          verified={verified}
          setShowProgress={setShowProgress}
          setProg={setProg}
          setTotalRecords={setTotalRecords}
          setClearForm={setClearForm}
          clearForm={clearForm}
          showProgress={showProgress}
          setActiveStep={setActiveStep}
        />
      )}
      
      {/* Table after verification */}
      {!errorResponses.length &&
        verified &&
        excelData.length > 0 &&
        !showProgress &&
        !clearForm && (
          <ReusableTable
            data={currentRows}
            currentPage={currentPage}
            pageNumbers={[...Array(totalPages)].map((_, i) => i + 1)}
            setCurrentPage={setCurrentPage}
          />
        )}

      {/* Success Message */}
      {clearForm && (
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center">
            <ClearForm
              message="Data Uploaded Successfully!"
              redirectPath="/instdashboard"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadLot;
